module.exports = __webpack_public_path__ + "static/img/downloadapp.9c605d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/portal/downloadapp.png
// module id = 166
// module chunks = 18